var vintools = vintools || {}; vintools["scripts"] =
webpackJsonpvintools__name_([3],{

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var vin65 = vin65;

var vin65CustomJS = {
	global: {
		init: function init() {
			vin65CustomJS.global.closeModals();
		},
		closeModals: function closeModals() {
			$(document).keyup(function (e) {
				if (e.key === "Escape" && $(".vt__modal-cart").hasClass("vt__modal-cart--visible")) {
					// Close the modal/menu
					$(".vt__modal-cart").removeClass("vt__modal-cart--visible");

					//  Return focus to the element that invoked it
					$('#v65-toggleModalCart').focus();
				}
			});
		}
	},
	navigation: {
		init: function init() {
			vin65CustomJS.navigation.scrollToLink();
		},
		scrollToLink: function scrollToLink() {
			$(window).on('click', 'a[href^=#]', function (e) {
				e.preventDefault();
				var $this = $(this),
				    href = $this.attr('href'),
				    elementOffset = $(href).offset().top,
				    distance = elementOffset;

				$("html, body").animate({ scrollTop: distance }, 500, "swing");
			});
		}
	}
};

//On Window Load function
$(window).load(function () {
	//Initiate Scripts
	vin65CustomJS.global.init();
	vin65CustomJS.navigation.init();
});

/***/ })

},[165]);


// WEBPACK FOOTER //
// scripts.min.js